<div class="failed-payment">
    <div>


        <h1>Your account is locked</h1>
        <div class="info-panel">
            <i class="fa fa-credit-card"></i>
            <div class="info-text">
                <div class="unable-info">We were not able to collect your last payment.</div>
                <div class="general-info">Please contact your admin to update your account's payment details to login to allo.</div>
            </div>
        </div>
    </div>
</div>
